import { render, staticRenderFns } from "./DrawerHeader.vue?vue&type=template&id=01fc5953&scoped=true"
import script from "./DrawerHeader.vue?vue&type=script&lang=js"
export * from "./DrawerHeader.vue?vue&type=script&lang=js"
import style0 from "./DrawerHeader.vue?vue&type=style&index=0&id=01fc5953&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fc5953",
  null
  
)

export default component.exports